import { render } from "./TextButtons.vue?vue&type=template&id=8ee729fa"
import script from "./TextButtons.vue?vue&type=script&lang=ts"
export * from "./TextButtons.vue?vue&type=script&lang=ts"

import "./TextButtons.vue?vue&type=style&index=0&id=8ee729fa&lang=less"
script.render = render

export default script